import { jsx as _ } from "react/jsx-runtime";
import s from "react";
import { Interactive as w } from "./components/Interactive/Interactive.js";
import { clsx as A } from "./utils/clsx.js";
import { useInstance as C } from "./utils/hooks.js";
import { clamp01 as b } from "./utils/math.js";
import './assets/Rail.css';const P = "_virtual_sn3qq_1", T = "_root_sn3qq_5", y = "_active_sn3qq_13", z = "_scroller_sn3qq_17", M = "_content_sn3qq_27", R = "_thumb_sn3qq_42", a = {
  virtual: P,
  root: T,
  "rail-y": "_rail-y_sn3qq_12",
  "rail-x": "_rail-x_sn3qq_13",
  active: y,
  scroller: z,
  "no-x-scroll": "_no-x-scroll_sn3qq_21",
  "no-y-scroll": "_no-y-scroll_sn3qq_24",
  content: M,
  thumb: R
};
function E() {
  return {
    pos: 0,
    ratio: 1,
    height: 0,
    offset: 0,
    dragging: !1,
    dragStartAtCursor: 0,
    dragStartAtPos: 0,
    movementMultiplier: 1
  };
}
function X(d) {
  const {
    axis: l,
    pos: n,
    size: e,
    scrollSize: g,
    rootRef: v,
    setRootActive: c,
    minThumbSize: i
  } = d, o = s.useMemo(() => l === "x" ? {
    sizeCSS: "width",
    offsetCSSTransform: "translateX",
    scrollToSide: "left",
    mousePosAxis: "clientX"
  } : {
    sizeCSS: "height",
    offsetCSSTransform: "translateY",
    scrollToSide: "top",
    mousePosAxis: "clientY"
  }, []), [S, m] = s.useState(!1), t = C(E);
  t.pos = n, t.ratio = b(e / g), t.height = e * t.ratio, t.offset = n * t.ratio, t.height < i && (t.height = i, t.offset = n * t.ratio * ((e - i) / e)), t.movementMultiplier = 1 / t.ratio;
  const h = s.useCallback((r) => {
    t.dragging = !0, t.dragStartAtPos = t.pos, t.dragStartAtCursor = r[o.mousePosAxis], m(!0), c(!0);
  }, []);
  s.useEffect(() => {
    const r = (q) => {
      var f;
      if (!t.dragging)
        return;
      const x = q[o.mousePosAxis] - t.dragStartAtCursor;
      (f = v.current) == null || f.scrollTo({
        [o.scrollToSide]: t.dragStartAtPos + x * t.movementMultiplier,
        behavior: "auto"
      });
    }, u = () => {
      t.dragging && (t.dragging = !1, m(!1), c(!1));
    };
    return window.addEventListener("mousemove", r), window.addEventListener("mouseup", u), () => {
      window.removeEventListener("mousemove", r), window.removeEventListener("mouseup", u);
    };
  }, []);
  const p = {
    [o.sizeCSS]: `${t.height}px`,
    transform: `${o.offsetCSSTransform}(${t.offset}px)`
  };
  return /* @__PURE__ */ _("div", { className: a[`rail-${l}`], children: /* @__PURE__ */ _(
    w,
    {
      showPointer: !1,
      style: p,
      className: A(a.thumb, { [a.active]: S }),
      onMouseDown: h
    }
  ) });
}
export {
  X as R,
  a as s
};
